import React from 'react'
import PropTypes from 'prop-types'
import styles from './_mid2018Community.css'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import Title from 'components/landing/shared/Title'
import Button from 'components/util/Button'
import Caption from 'components/landing/shared/Caption'
import whiteLogo from 'images/year-in-review/2018/midyear/afi/white.png'

import activity from 'images/year-in-review/2018/midyear/icons/activity.png'
import distance from 'images/year-in-review/2018/midyear/icons/distance.png'
import elevation from 'images/year-in-review/2018/midyear/icons/elevation.png'
import friends from 'images/year-in-review/2018/midyear/icons/friends.png'
import routes from 'images/year-in-review/2018/midyear/icons/routes.png'
import time from 'images/year-in-review/2018/midyear/icons/time.png'
import workout from 'images/year-in-review/2018/midyear/icons/workout.png'

function Community (props) {
  const {
    toggleCommunityStats,
    showCommunityStats,
    showSponsor,
  } = props

  return (
    <div className={styles.community}>
      <Title align='center' color='black'>
        <FormattedMessage
          id='midyear.2018.community.title'
          defaultMessage={`We Achieved\nTogether`}
        />
      </Title>

      <div className={styles.statsContainer}>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <div className={styles.iconWrapper}>
              <img src={workout} className={styles.icon} />
            </div>
            <Title className={styles.statTitle} color='white'>
              <FormattedMessage
                id='midyear.2018.community.activity_trends.title'
                defaultMessage={'+18% Recovery Workouts'}
              />
            </Title>
            <Caption color='white'>
              <FormattedMessage
                id='midyear.2018.community.activity_trends.caption'
                defaultMessage={'Recovery is becoming more important in 2018, with athletes logging more recovery workouts than in 2017.'}
              />
            </Caption>
          </div>

          <div className={styles.stat}>
            <div className={styles.iconWrapper}>
              <img src={activity} className={styles.icon} />
            </div>
            <Title className={styles.statTitle} color='white'>
              <FormattedMessage
                id='midyear.2018.community.unique_activities.title'
                defaultMessage={`3 Most\nUnique Activities`}
              />
            </Title>
            <ul className={styles.activityList}>
              <FormattedHTMLMessage
                id='midyear.2018.community.unique_activities.list'
                defaultMessage={`
                  <li>Zottman Curl - Forearms</li>
                  <li>Neck Resistance</li>
                  <li>Spider Curl</li>
                `}
              />
            </ul>
            <Caption color='white'>
              <FormattedMessage
                id='midyear.2018.community.unique_activities.caption'
                defaultMessage={'Athletes kept their workouts fresh with unique and challenging moves.'}
              />
            </Caption>
          </div>

          <div className={styles.stat}>
            <div className={styles.iconWrapper}>
              <img src={routes} className={styles.icon} />
            </div>
            <Title className={styles.statTitle} color='white'>
              <FormattedMessage
                id='midyear.2018.community.new_routes.title'
                defaultMessage={`41,569,594\nNew Routes`}
              />
            </Title>
            <Caption color='white'>
              <FormattedMessage
                id='midyear.2018.community.new_routes.caption'
                defaultMessage={'Athletes created shared routes all over the world to keep their activities interesting.'}
              />
            </Caption>
          </div>

          <div className={styles.stat}>
            <div className={styles.iconWrapper}>
              <img src={elevation} className={styles.icon} />
            </div>
            <Title className={styles.statTitle} color='white'>
              <FormattedMessage
                id='midyear.2018.community.total_elevation.title'
                defaultMessage={'8,361,760,911 Feet in Elevation'}
              />
            </Title>
            <Caption color='white'>
              <FormattedMessage
                id='midyear.2018.community.total_elevation.caption'
                defaultMessage={'Athletes took their activities higher than ever. Over 288,247 times the height of Everest. '}
              />
            </Caption>
          </div>

          { showCommunityStats ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={workout} className={styles.icon} />
              </div>
              <Title className={styles.statTitle} color='white'>
                <FormattedMessage
                  id='midyear.2018.community.total_workouts.title'
                  defaultMessage={`68,050,869\nTotal Workouts\nLogged`}
                />
              </Title>
              <Caption color='white'>
                <FormattedMessage
                  id='midyear.2018.community.total_workouts.caption'
                  defaultMessage={'Other most popular ways MapMy athletes track workouts: MyFitnessPal, Polar, Suunto & Endomondo.'}
                />
              </Caption>
            </div>
          : null }

          { showCommunityStats ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={distance} className={styles.icon} />
              </div>
              <Title className={styles.statTitle} color='white'>
                <FormattedMessage
                  id='midyear.2018.community.combined_distance.title'
                  defaultMessage={`236,227,937\nMiles Combined\nDistance`}
                />
              </Title>
              <Caption color='white'>
                <FormattedMessage
                  id='midyear.2018.community.combined_distance.caption'
                  defaultMessage={'Athletes hit the ground running, walking, and biking as the most popular ways to stay active.'}
                />
              </Caption>
            </div>
          : null }

          { showCommunityStats ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={time} className={styles.icon} />
              </div>
              <Title className={styles.statTitle} color='white'>
                <FormattedMessage
                  id='midyear.2018.community.total_hours.title'
                  defaultMessage={`51,216,984 Hours\nSpent Working Out`}
                />
              </Title>
              <Caption color='white'>
                <FormattedMessage
                  id='midyear.2018.community.total_hours.caption'
                  defaultMessage={'Athletes sweat and then sweat some more, logging more than 5,846 years in 6 months!'}
                />
              </Caption>
            </div>
          : null }

          { showCommunityStats ?
            <div className={styles.stat}>
              <div className={styles.iconWrapper}>
                <img src={friends} className={styles.icon} />
              </div>
              <Title className={styles.statTitle} color='white'>
                <FormattedMessage
                  id='midyear.2018.community.new_friends.title'
                  defaultMessage={`534,743\nNew\nFriends`}
                />
              </Title>
              <Caption color='white'>
                <FormattedMessage
                  id='midyear.2018.community.new_friends.caption'
                  defaultMessage={'Athletes worked out while making connections, sharing on social, and staying motivated.'}
                />
              </Caption>
            </div>
          : null }
        </div>

        { showCommunityStats ? null :
          <div className={styles.callToActionWrapper}>
            <Button
              className={styles.callToAction}
              size="medium"
              type="mmr"
              onClick={toggleCommunityStats}
            >
              <FormattedMessage
                id='midyear.2018.community.more'
                defaultMessage={'More Community Stats'}
              />
            </Button>
          </div>
        }
      </div>

      <div className={styles.communityFooter}>
        <Title align='center' color='white'>
          <FormattedMessage
            id='midyear.2018.community.dreaming'
            defaultMessage={'Keep Dreaming Fearlessly'}
          />
        </Title>
        { showSponsor ?
          <div className={styles.byline}>
            <img src={whiteLogo} />
          </div>
        : null }
      </div>

    </div>
  )
}

Community.propTypes = {
  toggleCommunityStats: PropTypes.func,
  showCommunityStats: PropTypes.bool,
  showSponsor: PropTypes.bool,
}

export default Community



// WEBPACK FOOTER //
// ./src/components/yearInReview/2018/midyear/Community/index.js